import { ApiType } from "@gymflow/common";
import { UserMemberBean } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useQueryMembershipLinkedMembers(
  {
    api,
    primarySubscriptionId,
  }: {
    api: ApiType;
    primarySubscriptionId?: number;
  },
  queryOptions?: Partial<UseQueryOptions<UserMemberBean[]>>,
) {
  return useQuery({
    queryKey: memberQueryKeys.membershipLinkedMembers(primarySubscriptionId),
    queryFn: async () => {
      const result = await api.memberApi.listMembershipLinkedMembers(
        primarySubscriptionId!,
      );
      return result.data as UserMemberBean[];
    },
    enabled:
      !!primarySubscriptionId &&
      (queryOptions === undefined || queryOptions.enabled),
  });
}
